import React, { useState, Context, ReactElement, Component } from "react";

export interface node_info_type {
  pod: string
  totalRootfs: string
  totalcpu: string
  totalmemory: string
  usedRootfs: string
  usedCPU: string
  usedmemory: string
}

const NodeInfoContext: Context<[node_info_type, React.Dispatch<React.SetStateAction<node_info_type>>]> = React.createContext<[node_info_type, React.Dispatch<React.SetStateAction<node_info_type>>]>([[] as unknown as node_info_type, (_value: any) => { }]);

const NodeInfoProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [node_info, set_node_info]: [node_info_type, React.Dispatch<React.SetStateAction<node_info_type>>] = useState([] as unknown as node_info_type);
  return (
    <NodeInfoContext.Provider value={[node_info, set_node_info]}>
      {props.children}
    </NodeInfoContext.Provider>
  )
}

export { NodeInfoContext, NodeInfoProvider };
